import React from "react";

interface InfoTableColumnProps {
  title?: string;
  data: { label: string; value: React.ReactNode, selectOption?: string[], clickSelect?: (type: string) => void, editable?: boolean, inputChange?: (value: string) => void }[];
  button?: React.ReactNode;
  toogle?: React.ReactNode;
  buttonSideTitle?: React.ReactNode;
}

export function InfoTableColumn({ title, data, button, toogle, buttonSideTitle }: InfoTableColumnProps) {
  return (
    <div>
      {title && <div className="mb-2 mt-2 flex items-center justify-between">
        <h4 className="font-semibold text-2xl">{title} {buttonSideTitle}</h4>
      </div>}

      <div className={`grid grid-cols-${data.length}`}>
        {data.map((item, index) => {

          if (item.label === "") {
            return <></>;
          }
          return (
            <div key={`label-${index}`} className="p-2 border-gray/50 border-r-0 flex items-center justify-center bg-white/70 border-b border-l border-gray-800">
              {item.label}
            </div>
          )
        })}

        {data.map((item, index) => {
          return (
            <div key={`value-${index}`} className={`p-2 flex items-center justify-center ${index % 2 === 0 ? "bg-white/30" : "bg-white/50"}`}>

              {item.selectOption &&
                <select onChange={el => item.clickSelect && item.clickSelect(el.target.value)}>
                  {item.selectOption?.map(option => <option>{option}</option>)}
                </select>}
              {item.editable && <input name={`editable${index}`} defaultValue={item.value as string} onChange={e => item.inputChange && item.inputChange(e.target.value)}></input>}
              {(!item.editable && !item.selectOption) && item.value}

            </div>
          )
        })}
      </div>

      {toogle && <div className="mt-2">{toogle}</div>}

      {button && <div className="flex mt-4 items-center justify-between">{button}</div>}
    </div>
  );
}
